import '~/app/javascript/src/base';
import '~/app/assets/javascripts/application/sitewide';

import '~/app/assets/javascripts/application/marketing_landing_pages/allowance';
